import React from "react";


export default function ImageModal({ src, caption, onClose }) {
    if (!src) return null;
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70" onClick={onClose}>
            <div className="relative max-w-6xl w-auto mx-4" onClick={(e) => e.stopPropagation()}>
                <button
                    onClick={onClose}
                    className="absolute -right-4 -top-4 bg-white rounded-full p-2 shadow-md hover:bg-gray-100"
                    aria-label="Cerrar imagen"
                >
                    <i className="bi bi-x-lg" />
                </button>
                <img src={src} alt={caption || ""} className="max-w-full max-h-[90vh] rounded shadow-lg object-contain" />
                {caption && <figcaption className="mt-2 text-center text-sm text-gray-300">{caption}</figcaption>}
            </div>
        </div>
    );
}
